// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

export * from './use-container-breakpoints';



// WEBPACK FOOTER //
// /local/src/internal/hooks/container-queries/index.ts